import { Component, HostListener, Input, OnInit } from '@angular/core';
import { MODE } from '../../shared/constant';

// Text box Component
@Component({
  selector: 'text-component',
  styleUrls: ['./../question.scss'],
  template: `
    <div
      [class.has-error]="(control?.value =='' && control?.invalid) || (control?.touched && control?.invalid) || (isSubmitClicked && control?.invalid)"
      [ngClass]="{'col-md-4 inline-padding': questiondata.params.inline == 3}"
      [ngClass]="{'col-md-3 inline-padding': questiondata.params.inline == 4}"
      [attr.id]="sectionId+'_'+questiondata.order+'_div'">
      <label-text [questiondata]="questiondata" [helptext]="questiondata.helpText"
                  [attrFor]="sectionId+'_'+questiondata.order"></label-text>
      <input *ngIf="questiondata.params?.validation?.type != 'phone'" class="form-control" [formControl]="control"
             [attr.type]="questiondata.type" [(ngModel)]="response" [attr.name]="sectionId+'_'+questiondata.order"
             [attr.id]="sectionId+'_'+questiondata.order" [attr.maxlength]="questiondata.params.charLimit"
             [style.width]="(!questiondata.params.inline)? questiondata.params.width + '%' : '' ">
      <input *ngIf="questiondata.params?.validation?.type == 'phone'" class="form-control" [textMask]="{mask: mask}"
             [formControl]="control" [attr.type]="questiondata.type" [(ngModel)]="response"
             [attr.name]="sectionId+'_'+questiondata.order" [attr.id]="sectionId+'_'+questiondata.order"
             [style.width]="(!questiondata.params.inline)? questiondata.params.width + '%' : '' ">
      <errorMessages *ngIf="mode != 'readOnly'" [control]='control' [params]='questiondata.params'
                     [isSubmitClicked]='isSubmitClicked'></errorMessages>
      <br/>
    </div><br *ngIf="!questiondata.params.inline"/>
  `,
})
export class TextBoxComponent implements OnInit {
  @Input() questiondata: any;
  @Input() control: any;
  @Input() sectionId: any;
  @Input() isSubmitClicked;
  @Input() mode: string;
  @Input() questions: any;

  private response = '';
  private mask = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  ngOnInit() {
    this.initControl();
  }

  ngOnChanges(changes: any) {
    if (changes.mode) {
      this.initControl();
    }
  }

  initControl() {
    (this.mode == MODE.READONLY) ? this.control.disable(true) : this.control.enable(true);
    if (this.questiondata.iterations) this.response = this.response || this.questiondata.iterations[0].responseText;
    this.control.setValue(this.response);
  }

  @HostListener('input', ['$event']) OnChange(event) {
    let value: string = event.target.value;
    if (value) {
      if (this.questiondata.params.validation != null && this.questiondata.params.validation.type == 'phone') {
        value = value.split('-').join('');
        let pattern = /^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$/gm;
        if (pattern.test(value)) {
          this.control.setValue(value);
        }
      } else {
        let pattern = /(^\s\a*)/g;
        if (pattern.test(value)) {
          this.control.setValue(value.trim());
        } else {
          this.control.setValue(value);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/form/controls/textbox.component.ts